import { useQuery } from "@tanstack/react-query";
import { getFeedWebByFeedId } from "../../../service/feed";
import { ReactComponent as Check } from "../../../assets/images/icon/check.svg";

const useGetFeedWebByFeedId = (feedId: number, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['feedWebByFeedId', feedId],
        queryFn: () => getFeedWebByFeedId(feedId, responseQuery),
        select: (res) => res.data.data.getFeedWebByFeedId,
    });

    return query
}

const CommentDeleteRender = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
    <Check width={16} height={16} stroke={'var(--secondarys100)'} />
    <div className="body/b2 base/white">
        댓글이 삭제되었습니다.
    </div>
</div>;

export { useGetFeedWebByFeedId, CommentDeleteRender }